<template>
  <div id="chart">
    <apexchart
      type="area"
      height="100%"
      :options="chartOptions"
      :series="series"
    />
  </div>
</template>

<script>
import VueApexCharts from "vue3-apexcharts";

export default {
  name: "ChartPerform",
  components: { apexchart: VueApexCharts },
  props: {
    parseData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      series: [
        {
          name: "Jumlah Tiket",
          data: [], // awal kosong
        },
      ],
      chartOptions: {
        chart: { type: "area", height: 300 },
        xaxis: {
          categories: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "Mei",
            "Jun",
            "Jul",
            "Agu",
            "Sep",
            "Okt",
            "Nov",
            "Des",
          ],
        },
        stroke: { curve: "smooth" },
        colors: ["#1E90FF"],
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.5,
            opacityTo: 1,
          },
        },
      },
    };
  },
  mounted() {
    // Isi awal saat komponen pertama kali dimuat
    this.updateChart();
  },
  watch: {
    // 🔁 Update chart setiap kali parseData berubah
    parseData: {
      handler() {
        this.updateChart();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    updateChart() {
      if (Array.isArray(this.parseData) && this.parseData.length > 0) {
        this.series = [
          {
            name: "Jumlah Tiket",
            data: this.parseData,
          },
        ];
      } else {
        this.series = [
          {
            name: "Jumlah Tiket",
            data: new Array(12).fill(0),
          },
        ];
      }
    },
  },
};
</script>

<style scoped>
#chart {
  width: 100%;
  height: 100%;
}
</style>
